import React, { useCallback, useEffect, useRef, useState } from "react";

import { ShutdownTypeType } from "./ShutdownLineTypes";

function ShutdownLine({
  region,
  outages_types,
  onCheckboxChanged,
  shutdownTypeColors,
  existingShutdowns,
  currentSelections = [],
  userHasInteracted = false,
}) {
  const [selectedOutages, setSelectedOutages] = useState<Array<number>>([]);
  const isUserChange = useRef(false);

  // Initialize selected outages based on existing shutdowns or current selections
  useEffect(() => {
    let nextOutages: number[] = [];
    if (userHasInteracted) {
      nextOutages = currentSelections || [];
    } else if (currentSelections && currentSelections.length > 0) {
      nextOutages = currentSelections;
    } else if (existingShutdowns && existingShutdowns.length > 0) {
      // Fallback to existing shutdowns for initial load
      existingShutdowns.forEach((shutdown) => {
        const regionInShutdown = shutdown.regions.find(
          (r) => r.id === region.id,
        );
        if (
          regionInShutdown &&
          !nextOutages.includes(shutdown.shutdown_type.id)
        ) {
          nextOutages.push(shutdown.shutdown_type.id);
        }
      });
    }

    setSelectedOutages((prev) => {
      // Only update if actually different to prevent re-render loops
      if (
        prev.length === nextOutages.length &&
        prev.every((v, i) => v === nextOutages[i])
      ) {
        return prev;
      }
      return nextOutages;
    });
  }, [existingShutdowns, region.id, currentSelections, userHasInteracted]);

  useEffect(() => {
    if (isUserChange.current) {
      onCheckboxChanged(region.id, selectedOutages);
      isUserChange.current = false;
    }
  }, [region.id, selectedOutages, onCheckboxChanged]);

  const handleCheckboxChanged = useCallback((outages_type_id: number) => {
    setSelectedOutages((prev) =>
      prev.includes(outages_type_id)
        ? prev.filter((id) => id !== outages_type_id)
        : [...prev, outages_type_id],
    );
  }, []);

  return (
    <tr>
      <td className="w-auto border pl-3  border-gray-300">{region.name}</td>
      {outages_types.map((outages_type: ShutdownTypeType) => {
        if (outages_type.display_type !== 0) {
          return (
            <td
              className="w-auto text-center py-1 border border-gray-300"
              style={{
                backgroundColor: selectedOutages.includes(outages_type.id)
                  ? shutdownTypeColors[outages_type.id] || "gray"
                  : "transparent",
              }}
              key={outages_type.id}
            >
              <button
                name={region.id}
                className="w-full h-full"
                onClick={(e) => {
                  isUserChange.current = true;
                  handleCheckboxChanged(outages_type.id);
                }}
              >
                {selectedOutages.includes(outages_type.id) ? "вкл" : "выкл"}
              </button>
            </td>
          );
        }
        return null;
      })}
    </tr>
  );
}

export default ShutdownLine;
